<section class="alt-solutions">
  <h2 class="section-title" [innerHTML]="title"></h2>
  <div class="card-container">
    <article class="alt-card" *ngFor="let card of cards; trackBy: trackByCard">
      <div class="alt-image-box">
        <img [src]="card.image" [alt]="card.alt" />
      </div>
      <h3 class="title">{{ card.title }}</h3>
    </article>
  </div>
  <p class="note">
    {{ note }}
  </p>
</section>
